import { Flex } from '@components'

export const Section = ({ children, ...restProps }: any) => {
  return (
    <Flex direction='col' textAlign={'left'} place={'start'} {...restProps}>
      {children}
    </Flex>
  )
}
